export default {
  authStart: () => `auth/start`,
  token: () => `auth/token`,
  me: () => `auth/me`,
  logOut: () => `auth/log-out`,
}
